import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { EquipamentoDBService } from '../database/equipamento-db.service';
import { Capacitor } from '@capacitor/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService extends BaseService{
    override classname: string = 'EquipamentoService';
    public override route: string = 'equipamento';

    public override database = Capacitor.isNativePlatform() ? new EquipamentoDBService() : new EquipamentoDBService();

    public override novo(){
        return {
            componentes: [],
            checklist: []
        }
    }

    verificarControle(controle: string, equipamentoId: number): Observable<any>{
        return this.get('controle/verificar', {
            controle,
            equipamento_id: equipamentoId
        });
    }
}
